import { Model } from './Model';

export class WelcomeToPubcenterEmail extends Model {
  public apiPath = "sendWelcomeEmail";
  public className = 'welcomeToPubcenterEmail';
}